import { useTranslate } from '@festina-life/ui/hooks'

import { TransferButton } from '../../components/transferButton/TransferButton'
import { useTransferableVersionsInBlock } from '../../hooks/useTransferableVersionsInBlock'
import { useNavigationParams } from '../../system/useNavigationParams'
import { useSpecId } from '../../system/useSpecId'
import { useOperationsContext } from '../../workspace/operationsContext'

/** Transfers every version of the reconciliation spec in scope to an ancestor block. */
export const ReconciliationSpecTransferButton = () => {
  const translate = useTranslate()
  const specId = useSpecId()
  const { block } = useNavigationParams()
  const { reconciliationSpecCreateOperations } = useOperationsContext()

  const transferableOperations = useTransferableVersionsInBlock({
    operationsByBlock: reconciliationSpecCreateOperations,
    itemId: specId,
  })

  return (
    <TransferButton
      item={{
        itemId: specId,
        type: 'reconciliationSpec',
        operationName: specId,
        versionCount: transferableOperations.length,
        isTransferable: !!transferableOperations.length,
      }}
      transfer={{
        label: translate('reconciliationSpecViewer.topBar.actions.transfer'),
        description: translate(
          'transfer.confirmationModal.reconciliationSpec.description',
          { sourceBlock: block },
        ),
        onConfirm: ({ transfer }) =>
          transfer({
            shouldInvalidateCacheAfterTransfer: true,
            operationName: specId,
            operations: transferableOperations,
          }),
      }}
    />
  )
}
